<div>
    <button type="button" class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn performanceTrendBtn"
    (click)="OpenPopUp()"> {{ 'performanceTrend'| translate }}<span> *</span></button>
  <div style="display: block">
    <canvas baseChart 
      [datasets]="barChartData" 
      [labels]="barChartLabels" 
      [options]="barChartOptions"
      [colors]="barChartColors" 
      [chartType]="barChartType" 
      (chartHover)="chartHovered($event)"
      (chartClick)="chartClicked($event)">
    </canvas>

  </div>
</div>
